export default __webpack_public_path__ + "static/media/Theme8.7dbd1e0d.jpg";